import { formConstants as constants } from '../_constants/form.constants';
import { formService } from '../_services/form.service';
import { alertActions } from './alert.actions'

export function getFormById(formId) {
  return dispatch => {
    dispatch(request());

    formService.getById(formId)
      .then((form) => {
        dispatch(success(form));
      })
      .catch(() => {
        dispatch(failure());
        dispatch(alertActions.error("Could not retrieve the form at this time. Please try again."));
      });
  }

  function request() { return { type: constants.FORMS_RETRIEVE_REQUEST } }
  function success(form) { return { type: constants.FORMS_RETRIEVE_SUCCESS, form } }
  function failure() { return { type: constants.FORMS_RETRIEVE_FAILURE } }
}

export function search(params = {}) {
  return dispatch => {
    dispatch(request());

    formService.getAllScheduled(params)
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch(() => {
        dispatch(alertActions.error("Could not retrieve forms."));
      });
  }

  function request() { return { type: constants.FORMS_GETALL_REQUEST } }
  function success(collection) { return { type: constants.FORMS_GETALL_SUCCESS, collection } }
}
